export function getFromLocalStorageOrDefault<T>(key: string, defaultValue: T): T {
  const stored = localStorage.getItem(key);
  return stored !== null ? JSON.parse(stored) : defaultValue;
}
